<h2 mat-dialog-title>
  @if (!isTrial) {
    {{ 'CHANGE_EDITION_DIALOG.ACTIVE_CAMPAIGN.TITLE' | translate }}
  } @else {
    {{ 'CHANGE_EDITION_DIALOG.UPGRADE_FROM_TRIAL' | translate }}
  }
</h2>
<mat-dialog-content>
  <div class="select-product-edition">
    <div class="select-product-edition-text">
      {{ 'CHANGE_EDITION_DIALOG.ACTIVE_CAMPAIGN.SELECT_EDITION' | translate }}
    </div>

    <div class="app-info-edition-dropdown">
      <div class="app-icon">
        @if (data.appIconUrl) {
          <va-icon
            [diameter]="32"
            [iconName]="data.appIconUrl"
            [iconUrl]="data.appIconUrl + '=s256'"
          ></va-icon>
        }
      </div>
      <div class="app-name">
        {{ data.appName }}
      </div>
      @if (editions$ | async; as editions) {
        <mat-select
          class="edition-dropdown"
          [formControl]="selectedEditionIdControl"
          #select="matSelect"
          >
          @for (edition of editions; track edition) {
            <mat-option [value]="edition.editionId">
              <div class="edition-option">
                <div>
                  {{ edition.editionTitle }}
                </div>
                @if (edition.editionId === currentEditionId && select.panelOpen) {
                  <div class="badge">
                    {{ 'CHANGE_EDITION_DIALOG.ACTIVE_CAMPAIGN.CURRENT' | translate }}
                  </div>
                }
              </div>
            </mat-option>
          }
        </mat-select>
      } @else {
        <mat-spinner [diameter]="32" [strokeWidth]="4"></mat-spinner>
      }

    </div>
  </div>

  @if ((satisfiesDependency$ | async) === false) {
    <div class="dependent-product-cancellation-warning">
      <glxy-alert type="warning">
        <strong>{{ formattedDependentProductsNames }}</strong>
        {{ 'CHANGE_EDITION_DIALOG.DEPENDENT_PRODUCTS_CANCELLATION_WARNING' | translate }}
        <strong>{{ formattedDependentProductsNames }}.</strong>
      </glxy-alert>
    </div>
  }

  <div class="confirmation">
    <app-wsp-multisite-consent-box
      [selectedEditionId]="selectedEditionId"
      [wspMultisiteEditionDemo]="wspMultisiteEditionDemo"
      [wspMultisiteEditionProd]="wspMultisiteEditionProd"
      [currentEditionId]="currentEditionId"
    ></app-wsp-multisite-consent-box>
    <div class="checkbox-container">
      <mat-checkbox class="checkbox" color="primary" [(ngModel)]="confirmationCheckbox"></mat-checkbox>
      @if (!isTrial) {
        <span class="checkbox-text">
          {{
          selectedEditionId === wspMultisiteEditionDemo || selectedEditionId === wspMultisiteEditionProd
          ? ('MULTISITE_CONSENT_BOX.MULTISITE_CONFIRMATION' | translate)
          : ('CHANGE_EDITION_DIALOG.ACTIVE_CAMPAIGN.CONFIRMATION' | translate)
          }}
        </span>
      } @else {
        <span>
          {{ 'CHANGE_EDITION_DIALOG.TRIAL_CONFIRMATION' | translate }}
        </span>
      }
    </div>
  </div>
  @if (notInstantBillable) {
    <div class="change-edition-message">
      @if (!isTrial) {
        {{ 'CHANGE_EDITION_DIALOG.BEFORE_CHANGE' | translate }}
      } @else {
        {{ 'CHANGE_EDITION_DIALOG.BEFORE_UPGRADE' | translate }}
      }
      <a [routerLink]="['/billing/by-purchase']" [queryParams]="{ 'show-edit-payment-info': 'true' }">
        {{ 'COMMON.ACTION_LABELS.ADD' | translate }}
      </a>
    </div>
  }
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-stroked-button matDialogClose color="primary">
    {{ 'CHANGE_EDITION_DIALOG.ACTIVE_CAMPAIGN.CANCEL_BUTTON' | translate }}
  </button>
  <button
    mat-raised-button
    color="primary"
    (click)="activateEditionForApp()"
    [disabled]="
      (!isTrial && selectedEditionId === currentEditionId) ||
      !confirmationCheckbox ||
      submitting ||
      notInstantBillable ||
      currentEditionId === wspMultisiteEditionDemo ||
      currentEditionId === wspMultisiteEditionProd
    "
    >
    @if (!submitting) {
      @if (!isTrial) {
        {{ 'CHANGE_EDITION_DIALOG.ACTIVE_CAMPAIGN.CHANGE_EDITION_BUTTON' | translate }}
      } @else {
        {{ 'CHANGE_EDITION_DIALOG.UPGRADE_TO_PAID_BUTTON' | translate }}
      }
    } @else {
      <mat-spinner [diameter]="24" [strokeWidth]="4"></mat-spinner>
    }
  </button>
</mat-dialog-actions>
